import { useEffect } from "react";
import { api } from "@/lib/api";

export default function SEOHead({ pageKey }) {
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get(`/seo/${pageKey}`);
        if (!active) return;
        if (data?.title) document.title = data.title;
        const setMeta = (name, content) => {
          if (!content) return;
          let tag = document.querySelector(`meta[name="${name}"]`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("name", name);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        };
        setMeta("description", data?.description);
        setMeta("keywords", data?.keywords);
      } catch {
        /* ignore */
      }
    })();
    return () => { active = false; };
  }, [pageKey]);
  return null;
}
